<template>
  <div class="noise" ref="container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Noise from '@/scripts/Noise';

export default {
  name: 'Noise',

  data() {
    return {
      noise: null,
    };
  },

  mounted() {
    this.noise = new Noise(this.$refs.container, this.$refs.canvas);
  },
};
</script>

<style lang="scss" scoped>
.noise {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  pointer-events: none;

  mix-blend-mode: color-dodge;
}
</style>
